import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { OverlayBatteryCertificate } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './battery-certificate.actions';

interface Content {
    content: Loadable<OverlayBatteryCertificate>;
    error: string | null;
}

const initialState: Content = {
    content: null,
    error: null,
};

export const state = createFeature({
    name: 'batteryCertificate',
    reducer: createReducer(
        initialState,
        on(
            actions.loadBatteryCertificate,
            (state): Content => ({
                ...state,
                content: null,
                error: null,
            }),
        ),
        on(
            actions.loadBatteryCertificateSuccess,
            (state, { content }): Content => ({
                ...state,
                content: content,
            }),
        ),
        on(
            actions.loadBatteryCertificateFailure,
            (state, { error }): Content => ({
                ...state,
                error: error,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingPromise = createSelector(
            baseSelectors.selectContent,
            baseSelectors.selectError,
            (promiseContent, error) => promiseContent === null && error === null,
        );
        const selectLoadedContent = createSelector(
            baseSelectors.selectContent,
            (content) => content as Loaded<OverlayBatteryCertificate>,
        );
        return {
            selectIsLoadingPromise,
            selectLoadedContent,
        };
    },
});
